import { render, staticRenderFns } from "./StockReports.html?vue&type=template&id=dc83c930&scoped=true&external"
import script from "./StockReports.js?vue&type=script&lang=js&external"
export * from "./StockReports.js?vue&type=script&lang=js&external"
import style0 from "./StockReports.vue?vue&type=style&index=0&id=dc83c930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc83c930",
  null
  
)

export default component.exports